import React from 'react';
import '../css/LanguageSelection.css';

const LanguageSelection = ({ onSelectLanguage }) => {
  return (
    <div className="language-component">
      <div className="language-selection">
        <button onClick={() => onSelectLanguage('en')} onTouchStart={() => onSelectLanguage('en')}>English</button>
        <button onClick={() => onSelectLanguage('ar')} onTouchStart={() => onSelectLanguage('ar')}>العربية</button>
      </div>
      <p>الرجاء اختيار لغة</p>
    </div>
  );
};

export default LanguageSelection;
